var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8457_61165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9993 9.63883V7.63883C12.9993 5.43895 12.9993 4.339 12.3159 3.65559C11.6325 2.97217 10.5325 2.97217 8.33268 2.97217H6.33268C4.1328 2.97217 3.03285 2.97217 2.34944 3.65559C1.66602 4.339 1.66602 5.43895 1.66602 7.63883V10.9722C1.66602 13.172 1.66602 14.272 2.34944 14.9554C3.03285 15.6388 4.1328 15.6388 6.33268 15.6388H7.33268",
    stroke: "#A65523",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.30542V3.63875M7.33333 2.30542V3.63875M4 2.30542V3.63875",
    stroke: "#A65523",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.3056C9 14.3056 9.66667 14.3056 10.3333 15.6389C10.3333 15.6389 12.451 12.3056 14.3333 11.6389",
    stroke: "#A65523",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 10.9722H7.33268M4.66602 7.63892H9.99935",
    stroke: "#A65523",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8457_61165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.972168)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteDone);
export default __webpack_public_path__ + "static/media/note-done.f54cae8d0237e7068221b4141b1029a9.svg";
export { ForwardRef as ReactComponent };